/**
 * @copyright © 2015, Rick Wong. All rights reserved.
 */
'use strict';

module.exports = require('object-assign');
